import { GRID_NODE_TYPES, MOBILE_BREAKPOINT_NAME } from 'layout-data-lib/GridLayoutDataTree/constants';
export const DATA_HS_GRID_ROOT_ID = 'data-hs-grid-root-id';
export const DATA_HS_GRID_SECTION_ID = 'data-hs-section-id';
export const DATA_HS_GRID_CONTAINER_ID = 'data-hs-container-id';
export const DATA_HS_GRID_MODULE_ID = 'data-hs-module-id';
export const GRID_DATA_ATTRIBUTE_NODE_MAP = {
  [GRID_NODE_TYPES.ROOT]: DATA_HS_GRID_ROOT_ID,
  [GRID_NODE_TYPES.SECTION]: DATA_HS_GRID_SECTION_ID,
  [GRID_NODE_TYPES.CONTAINER]: DATA_HS_GRID_CONTAINER_ID,
  [GRID_NODE_TYPES.MODULE]: DATA_HS_GRID_MODULE_ID
};
export const DND_GRID_AREA_CLASS_NAME = 'hs-container-root';
export const DND_GRID_AREA_SECTION_CLASS_NAME = 'dnd-grid-section';
export const DND_GRID_AREA_MODULE_CLASS_NAME = 'dnd-grid-module';
export const DND_GRID_AREA_CONTAINER_CLASS_NAME = 'dnd-grid-container';
export const DND_GRID_AREA_CLASS_NAME_NODE_MAP = {
  [GRID_NODE_TYPES.ROOT]: DND_GRID_AREA_CLASS_NAME,
  [GRID_NODE_TYPES.SECTION]: DND_GRID_AREA_SECTION_CLASS_NAME,
  [GRID_NODE_TYPES.CONTAINER]: DND_GRID_AREA_CONTAINER_CLASS_NAME,
  [GRID_NODE_TYPES.MODULE]: DND_GRID_AREA_MODULE_CLASS_NAME
};
export const DND_GRID_AREA_SECTION_CLASS_NAME_PREFIX = 'dnd-grid-section-';
export const DND_GRID_AREA_SECTION_CONTENT_CLASS_NAME = 'dnd-grid-section-content';
export const DND_GRID_AREA_SECTION_CONTENT_CLASS_NAME_PREFIX = 'dnd-grid-section-';
export const DND_GRID_AREA_CONTAINER_CLASS_NAME_PREFIX = 'dnd-grid-container-';
export const DND_GRID_AREA_MODULE_RENDERER_CLASS_NAMES = ['hs_cos_wrapper', 'hs_cos_wrapper_widget', 'hs_cos_wrapper_type_module'];
export const DND_GRID_AREA_MODULE_INNER_ELEMENT_ID_PREFIX = 'hs_cos_wrapper_';
export const DND_GRID_AREA_MODULE_ELEMENT_ID_PREFIX = 'hs_cos_wrapper_widget_';
export const DND_GRID_AREA_BACKGROUND_CLASS_NAME = 'dnd-grid-background';
export const DND_GRID_AREA_BACKGROUND_LAYERS_WRAPPER_CLASS_NAME_PREFIX = 'background-layers-';
export const DND_GRID_AREA_BACKGROUND_LAYER_CLASS_NAME_PREFIX = 'background-';

// Value is a space-separated list of breakpoint names with an image/video/
// gradient layer, matched via `[...~="{breakpoint}"]`. Scopes the
// variant-bg suppression rule so it follows current DOM state.
export const DATA_HS_SECTION_HAS_BG_MEDIA = 'data-hs-section-has-bg-media';
export const DEFAULT_BREAKPOINT_NAME = 'default';
export const DEFAULT_HORIZONTAL_PADDING = 32;
export const DEFAULT_VERTICAL_PADDING = 80;
export const DEFAULT_SECTION_PADDING = `padding: ${DEFAULT_VERTICAL_PADDING}px ${DEFAULT_HORIZONTAL_PADDING}px;`;
export const SECTION_PADDING_PRESET_SIZE = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE'
};
export const SECTION_PADDING_PRESETS = {
  [DEFAULT_BREAKPOINT_NAME]: {
    [SECTION_PADDING_PRESET_SIZE.SMALL]: {
      vertical: 48,
      horizontal: 32
    },
    [SECTION_PADDING_PRESET_SIZE.MEDIUM]: {
      vertical: 64,
      horizontal: 48
    },
    [SECTION_PADDING_PRESET_SIZE.LARGE]: {
      vertical: 96,
      horizontal: 64
    }
  },
  [MOBILE_BREAKPOINT_NAME]: {
    [SECTION_PADDING_PRESET_SIZE.SMALL]: {
      vertical: 24,
      horizontal: 16
    },
    [SECTION_PADDING_PRESET_SIZE.MEDIUM]: {
      vertical: 40,
      horizontal: 20
    },
    [SECTION_PADDING_PRESET_SIZE.LARGE]: {
      vertical: 64,
      horizontal: 24
    }
  }
};
export const SECTION_PADDING_SLIDER_MAX = {
  [DEFAULT_BREAKPOINT_NAME]: 120,
  [MOBILE_BREAKPOINT_NAME]: 80
};